import { useEffect, useMemo, useState } from 'react';
import { SettingsModel } from '../models/SettingsModel';

/**
 * Navy Phase 0 Settings' model for the signed-in user in the active
 * organisation. It lives for the session, so a saved change survives leaving
 * Settings, and it's rebuilt when the user or the organisation changes, as the
 * Library's is (useLibraryModel), so one org's users never show in another's.
 */
export const useSettingsModel = (me) => {
  const scope = me ? `${me.id}:${me.org_id}` : null;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- rebuilt per scope on purpose
  return useMemo(() => new SettingsModel(me), [scope]);
};

/** The model's state, kept current. */
export const useSettingsState = (model) => {
  const [state, setState] = useState(() => model.getState());
  useEffect(() => {
    setState(model.getState());
    return model.subscribe(setState);
  }, [model]);
  return state;
};
